export default __webpack_public_path__ + "static/media/paymentTutorial_pc_middle_Hk.2a70805a.webp";